/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql, Link } from 'gatsby';


import Header from './header/header';

import Footer from '../components/footer';
import CookieConsent from 'react-cookie-consent';
import './default.scss';

const Layout = ({ children, ...rest }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      cookieSVG: file(relativePath: { eq: "cookie.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <>
      <Header />
      <div>
        <main {...rest}>{children}</main>
      </div>
      <Footer siteTitle={data.site.siteMetadata.title} />

      <CookieConsent
        location="none"
        containerClasses="drop-shadow"
        contentClasses="consent-content px-4 py-4"
        // contentStyle={{backgroundImage: data.cookieSVG.publicURL}}
        buttonText="Accept"
        buttonClasses="btn btn-primary"
        cookieName="cookie_concent_granted"
        disableStyles={true}
        // style={{ background: "#231f20", fontSize: "14px" }}
        // buttonStyle={{ fontSize: "12px", borderRadius: "10px" }}
        acceptOnScroll={false}
        onAccept={({ acceptedByScrolling }) => {
          if (acceptedByScrolling) {
            // triggered if user scrolls past threshold
            // alert("Accept was triggered by user scrolling");
          } else {
            // alert("Accept was triggered by clicking the Accept button");
          }
        }}
        // enableDeclineButton
        // onDecline={() => {
        // 	Cookies.remove('_ga')
        // 	Cookies.remove('_gid')
        // }}
        // declineButtonStyle={{ margin: "5px 15px", fontSize: "12px" }}
        // setDeclineCookie={true}
        sameSite={`strict`}
      >
        <img src={data.cookieSVG.publicURL} alt="a cookie" />
        <p>
          Our website uses cookies to ensure you get a personalised
          experience.
        </p>
        <Link to="/privacy-policy">More information</Link>
      </CookieConsent>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
